import { SIZE } from 'common/sizes';
import styled from 'styled-components';

export const Root = styled.div`
  max-width: 1147px;
  width: auto;
  display:inline-block;
  border-radius: 5px;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  position:relative;
`;

export const MenuFilter = styled.div`
    max-width: 299px;
    height: 280px;
    margin-top: ${SIZE.TWO}px;
    margin-left: 0;
    display: none;
    position: absolute;
    border-radius: 5px;
    box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
    background-color: #ffffff;
    z-index: 1;
    padding: ${SIZE.TWO}px 0px;
`
export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;
`
export const List = styled.div`
  height: 280px;
  display: inline-block;
  overflox-x: hidden;
  overflow-y: auto;
  flex-direction: column;
  position:relative;
  &:after{
      content: " ";
      position: absolute;
      top: 0%;
      left: 0;
      height: 100%;
      margin-top: auto;
      margin-bottom: auto;
  }
`

export const Label = styled.div`
    width: 55px;
    height: 19px;
    flex-grow: 0;
    padding-left: ${SIZE.THREE}px;
    margin-bottom: ${SIZE.TWO}px;
    font-family: Rubik;
    font-size: 16px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
    color: #ff7319;
`

export const FilterContainer = styled.div`
  display:inline-block;
`;

export const ButtonFilter = styled.button`
  display: flex;
  flex-direction: row;
  height: 35px;
  font-family: Rubik;
  font-size: 16px;
  text-align: left;
  color: #272727;
  padding: 0px 16px;
  border: unset;
  display:inline-block;
  background-color: #ffffff;
  cursor: pointer;
  margin: 0px ${SIZE.TWO}px;
  &:hover, &:focus {
    background-color: #f5f5f5;
    border-radius: 5px;
  }
  &:hover ~ ${MenuFilter} {
    display: block;
  }
  &:focus {
      outline: none;
  }
`